<template>
<div v-if="messages" class="chat">
    <div id="mainMessages" class="chat_converse">
        <chat-message
            v-for="(message, i) in messages"
            :key="i"
            :value="message"
            :myUser="user"
            right
            showUser
        />
    </div>
    <chat-form
        v-if="!disabled && !is_banned && !publicUser"
        v-model="message"
        @success="success"
        @delete="removeFile"
        :moderate="chat.moderate"
        :send="send"
        :user="user"
        :max="255"
        ref="form"
        showupload
    />
    <div v-else-if="is_banned" class="card my-0 px-3 py-2 text-danger"> {{$t('chat.you_are_banned')}} </div>
    <div v-else-if="publicUser" class="card my-0 px-3 py-2"> {{$t('chat.needs_login')}} </div>
    <div v-else-if="disabled" class="card my-0 px-3 py-2"> {{$t('chat.end')}} </div>
</div>
</template>

<script>
import ChatForm from '../ChatComponents/ChatForm';
import ChatMessage from '../ChatComponents/ChatMessage';
import WSChat from '../ChatComponents/mixins/WSChat';

export default {

    name: 'ChatLive',

    components: {
        ChatMessage,
        ChatForm,
    },

    props: {
        user: Object,
        value: Object,
        disabled: [Boolean, Number],
    },

    mixins: [
        WSChat,
    ],

    data() {
        return {
            autoScroll: true,
        };
    },

    computed: {

        chat: {
            get() { return this.value; },
            set(value) { this.$emit('input', value); },
        },

        publicUser() {
            return this.$store.getters.USER.public;
        },
    },

    methods: {
        success(upload = this.upload) {
            this.upload = {
                // o upload-local devolve o nome original em `name`
                filename: upload.filename || upload.name,
                hash: upload.hash,
                height: upload.height,
                host: upload.host,
                mime: upload.mime,
                original_file: upload.original_file,
                path: upload.path,
                size: upload.size,
                type: upload.type,
                width: upload.width,
                status: 1,
            };
        },

        send() {
            this.addMessage(...arguments);
            this.$refs.form.reset();
            this.upload = null;
        },

        removeFile() {
            axios.delete(`/api/upload-local/delete/${this.upload.hash}`, {

            });
            this.$refs.form.reset(false);
            this.upload = null;
        },
    },
};
</script>

<style lang="sass" scoped>
.chat
    width: 100%
    display: flex
    flex-direction: column

.chat_converse
    position: relative
    display: flex
    flex-direction: column
    background: #fff
    height: calc(100vh - 285px)
    font-size: 12px
    line-height: 18px
    overflow-y: auto
    width: 100%
    float: right
    padding-bottom: 30px

/*Chatbox scrollbar*/
::-webkit-scrollbar
    width: 6px

::-webkit-scrollbar-track
    border-radius: 0

::-webkit-scrollbar-thumb
    margin: 2px
    border-radius: 10px
    background: rgba(0, 0, 0, 0.2)

</style>
